module.exports = __webpack_public_path__ + "static/img/bj.22436f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/staffDialog/img/bj.png
// module id = Knvf
// module chunks = 226